import { h, Component } from 'preact';
import 'store/bolt/cookies';
import { accessNested, joinClasses } from 'utils/utils';
import Store from 'store/store';
import Toggle from 'components/bolt/toggle/toggle';
import HTML from 'components/core/html/html';
import s from 'components/bolt/cookiesPreference/cookiesPreference.sss';
import Cookies from 'js-cookie';
import * as categories from 'utils/gdpr/categories';
const POWSTER_COOKIE = 'pow-cookie-cats-';

const copyAlt = {
	STRICTLY_NECESSARY: 'NECESSARY'
};

export default class CookiesPreference extends Component {
	constructor(props) {
		super(props);
		this.state = {
			allowAll: false,
			STRICTLY_NECESSARY: true,
			PERFORMANCE: false,
			FUNCTIONAL: false,
			TARGETING: false,
			SOCIAL: false,
		};
		this.toggleAllowAll = this.toggleAllowAll.bind(this);
		this.saveSettings = this.saveSettings.bind(this);
		this.setCategories = this.setCategories.bind(this);
	}

	componentDidMount() {
		this.setCategories();

		Store.on('SET_COOKIES', this.setCategories);
	}

	componentWillUnmount() {
		Store.off('SET_COOKIES', this.setCategories);
	}

	setCategories(allowedCats) {
		if (!allowedCats) {
			const appId = accessNested(Store.get(), 'appData.meta.id', '');
			let cookieCategories;
			try {
				cookieCategories = JSON.parse(Cookies.get(POWSTER_COOKIE + appId));
			} catch (err) {}
			this.allowedCategories = cookieCategories || categories.get() || [];
		} else {
			this.allowedCategories = allowedCats;
		}

		this.allowedCategories.forEach(cat => {
			let newState = {};
			newState[cat] = true;
			this.setState(newState);
		});

		if (!this.props.categories.some(cat => !this.state[cat])) {
			this.setState({ allowAll: true });
		}
	}

	toggleAllowAll() {
		let newState = !this.state.allowAll;
		this.setState({
			allowAll: newState,
			PERFORMANCE: newState,
			FUNCTIONAL: newState,
			TARGETING: newState,
			SOCIAL: newState,
		});
	}
	toggle(prop) {
		let newState = !this.state[prop];
		let allowAll = newState && this.props.categories.every(cat => cat === prop || this.state[cat]);
		this.setState({ allowAll, [prop]: newState });
	}

	saveSettings() {
		Store.emit('COOKIE_PREFERENCES_CLOSE');
		Store.emit('COOKIE_BANNER_CLOSE');

		const getCategories = Object.keys(this.state).filter(k => k != 'allowAll');
		const allowedCategories = getCategories.filter(c => {
			return this.state[c] && this.props.categories.indexOf(c) > -1;
		});

		const deleteAndReload = this.allowedCategories.some(oldCat => !this.state[oldCat]);

		Store.emit('ACCEPT_COOKIES', this.state.allowAll ? this.props.categories : allowedCategories);

		if (deleteAndReload) {
			Store.emit('DELETE_ALL_COOKIES', { reload: true });
		}
	}

	renderGroup(type, required) {
		if (!required && !this.props.categories.includes(type)) {
			return;
		}
		const fontStyles = this.props.appData?.styling?.fontVariables || {};

		const copy = this.props.copy || {};
		let alt = copyAlt[type] || type;
		let title = copy['$' + type] || copy['$' + alt] || type;
		let description = copy['$' + type + '_DESCRIPTION'] || copy['$' + alt + '_DESCRIPTION'] || '';

		let content;
		if (required) {
			content = <HTML class={joinClasses(s.cookieAction, s.required, fontStyles.prefCentreCatRequired)} content={copy.$COOKIES_REQUIRED} markdown key="required" />;
		} else {
			content = <div class={s.cookieAction}><Toggle active={this.state[type]} onClick={() => this.toggle(type)} key="toggle" ariaLabel={title} /></div>;
		}

		return (
			<div class={s.preference} key={type}>
				<HTML class={joinClasses(s.cookieType, fontStyles.prefCentreCatTitle)} content={title} markdown key="title" />
				<HTML class={joinClasses(s.cookieDescription, fontStyles.prefCentreCatDescription)} content={description} markdown key="description" />
				{content}
			</div>
		);
	}

	render() {
		const {
			$COOKIES_TITLE,
			$COOKIES_DESCRIPTION,
			$COOKIES_ALLOW_ALL = 'Allow all',
			$SAVE_SETTINGS
		} = this.props.copy || {};

		const fontStyles = this.props?.appData?.styling?.fontVariables || {};

		const { categories, cookiePrefsOpen } = this.props;

		return (
			<div class={joinClasses(s.screenCover, cookiePrefsOpen && s.open)}>
				<div class={s.container}>
					<div class={s.top}>
						<HTML class={joinClasses(s.title, fontStyles.prefCentreTitle)} content={$COOKIES_TITLE} markdown />
						<HTML class={joinClasses(s.description, fontStyles.prefCentreDescription)} content={$COOKIES_DESCRIPTION} markdown />
						{categories.length > 1 && (
							<div class={s.preference}>
								<div class={joinClasses(s.disable, fontStyles.prefCentreDisableAll)}>
									{$COOKIES_ALLOW_ALL}
									<Toggle active={this.state.allowAll} onClick={this.toggleAllowAll} ariaLabel={$COOKIES_TITLE} />
								</div>
							</div>
						)}
					</div>
					<div class={s.middle}>
						{this.renderGroup('STRICTLY_NECESSARY', true)}
						{this.renderGroup('PERFORMANCE')}
						{this.renderGroup('FUNCTIONAL')}
						{this.renderGroup('TARGETING')}
						{this.renderGroup('SOCIAL')}
					</div>
					<div class={s.bottom}>
						<button class={joinClasses(s.save, fontStyles.prefCentreSaveBtn)} onClick={this.saveSettings}>
							{$SAVE_SETTINGS}
						</button>
					</div>
				</div>

			</div>
		);
	}
}
